type Props = {
  collapsed?: boolean;
};

export default function PettyCashIcon({ collapsed }: Props) {
  return (
    <span className="w-6 flex justify-center">
      <svg
        width="18"
        height="14"
        viewBox="0 0 18 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={collapsed ? {} : { transform: "scale(1.1)" }}
        className={collapsed ? "" : "relative left-[3px]"}
      >
        <path
          d="M1.5 6.32031H5.93826C6.08225 6.32028 6.22182 6.37005 6.33331 6.46116C6.4448 6.55228 6.52136 6.67914 6.55 6.82025C6.66536 7.38489 6.97221 7.89236 7.41864 8.2568C7.86508 8.62125 8.4237 8.82031 9 8.82031C9.57631 8.82031 10.1349 8.62125 10.5814 8.2568C11.0278 7.89236 11.3346 7.38489 11.45 6.82025C11.4787 6.67914 11.5552 6.55228 11.6667 6.46116C11.7782 6.37005 11.9178 6.32029 12.0617 6.32031H16.5M1.5 3.82031H16.5M2.75 1.32031H15.25C15.9404 1.32031 16.5 1.87996 16.5 2.57031V11.3203C16.5 12.0107 15.9404 12.5703 15.25 12.5703H2.75C2.05964 12.5703 1.5 12.0107 1.5 11.3203V2.57031C1.5 1.87996 2.05964 1.32031 2.75 1.32031Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
}
